<template>
  <div>
    <!-- 页面一 -->
    <div class="wrap page-one" v-loading="showLoading" v-if="pageType == 1">
      <!-- 轮播图 -->
      <div class="swiper-wrap">
        <div class="swiper">
          <swiper :options="swiperOption">
            <swiper-slide v-for="(item, index) in ActivityPicture" :key="index">
              <img :src="item.Url" alt="" />
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
      </div>
      <!-- 内容 -->
      <div class="content-wrap">
        <div>活动细则：</div>
        <!-- 细则 -->
        <div v-html="activityEntity.ActivityExplain"></div>
        <!--  -->
        <div class="has-num">
          已报名数量：{{
            activityEntity.JoinNum == null ? 0 : activityEntity.JoinNum
          }}台
        </div>
      </div>
      <!-- 按钮 -->
      <div class="page-one-bottom-btn">
        <van-button type="primary" size="large" @click="handleJoin"
          >报名</van-button
        >
      </div>
    </div>
    <!-- 页面二 -->
    <div
      class="wrap page-two"
      v-loading="showLoading"
      v-else-if="pageType == 2"
    >
      <div class="title">录入基本信息：</div>
      <!-- 表单页面 -->
      <div class="form-wrap">
        <van-form @submit="handleSubmit">
          <van-field
            v-model="temp.CustomerName"
            name="姓名"
            label="姓名"
            placeholder="姓名"
            :rules="[{ required: true, message: '请填写姓名' }]"
          />
          <van-field
            v-model="temp.CustomerPhone"
            name="电话"
            label="电话"
            placeholder="电话"
            :rules="[{ required: true, message: '请填写电话' }]"
          />

          <van-field
            v-model="temp.CustomerArea"
            name="小区"
            label="小区"
            placeholder="小区"
            :readonly="hasActivityArea"
            :rules="[{ required: true, message: '请填写小区' }]"
          />

          <!-- <van-field
            v-model="temp.CustomerBuilding"
            name="楼栋"
            label="楼栋"
            placeholder="楼栋"
            :rules="[{ required: true, message: '请填写楼栋' }]"
          /> -->
          <van-field
            v-model="temp.CustomerUnit"
            name="房号"
            label="房号"
            placeholder="房号"
            :rules="[{ required: true, message: '请填写房号' }]"
          />

          <div class="ptqk-title">拼团情况：</div>

          <van-field
            name="stepper"
            :label="item.TypeName"
            v-for="(item, index) in itemList"
            :key="index"
          >
            <template #input>
              <van-stepper
                v-model="item.JoinNum"
                min="0"
                input-width="60px"
                button-size="40px"
              />
            </template>
          </van-field>
          <div class="ptqk-title" style="margin-bottom: 0px">备注：</div>
          <van-field
            v-model="temp.Description"
            name="备注"
            placeholder="请填写备注"
            type="textarea"
          />

          <!-- 按钮 -->
          <div class="page-two-bottom-btn">
            <van-button
              type="primary"
              size="large"
              native-type="submit"
              :loading="submitLoading"
              >提交资料</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
    <!-- 页面三 -->
    <div
      class="wrap page-three"
      v-loading="showLoading"
      v-else-if="pageType == 3"
    >
      <div class="success-wrap">
        <div class="title">报名成功</div>
        <div style="padding: 20px 0px">
          已报名数量：{{ totalJoinNum == null ? 0 : totalJoinNum }}台
        </div>
        <div class="list">
          <div class="item" v-for="(item, index) in joinList" :key="index">
            <!-- 头像 -->
            <div class="icon">
              <img :src="item.HeadImgUrl" alt="" />
            </div>
            <!--  -->
            <div>空调数量{{ item.JoinNum == null ? 0 : item.JoinNum }}台</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
export default {
  data() {
    return {
      id: "",
      localStorageActivityKey: "activityId",
      localStorageLoginPathKey: "loginPath",
      hasLogin: 0, //1-已登录
      canJoin: 0, //1-可报名，
      canJoinMessage: "",
      activityEntity: {},
      activityCustomerEntity: null,
      sdkModel: {},
      ActivityPicture: [],
      swiperOption: {
        pagination: {
          el: ".swiper-pagination",
        },
        loop: true,
        autoplay: 5000,
      },
      showLoading: false,
      submitLoading: false,
      pageType: 1,
      temp: {
        ActivityId: "",
        CustomerArea: "",
        CustomerName: "",
        CustomerPhone: "",
        // CustomerBuilding: "",
        CustomerUnit: "",
        Description: "",
        DetailListJson: "",
      },
      tempEmpty: {}, // 临时存放空白对象
      formModel: {
        formatString: ["CustomerName"], // 编辑时，为空过滤为"&nbsp;"
        formatDate: ["Date"], // 编辑时，为空过滤为"1911-01-01 00:00:00"
      },
      rules: {
        CustomerName: [{ required: true, message: "请录入" }],
        CustomerPhone: [{ required: true, message: "请录入" }],
        // CustomerBuilding: [{ required: true, message: "请录入" }],
        CustomerUnit: [{ required: true, message: "请录入" }],
      },
      hasActivityArea: false, //是否有小区
      itemList: [],
      totalJoinNum: 0,
      joinList: [],
      currentIndex: null,
      cusWebUrl: "https://www.lungchuenjz.cn",
      thisWebUrl: "https://www.lungchuenjz.cn/customer/#/jl-activity?id=",
    };
  },
  computed: {},
  created() {
    if (this.$route.query.hasOwnProperty("id")) {
      this.id = this.$route.query.id;
    }
    if (!this.id) {
      this.id = localStorage.getItem(this.localStorageActivityKey);
    }
    this.tempEmpty = Object.assign({}, this.temp); // 复制对象
    // this.tempShowEmpty = Object.assign({}, this.tempShow);
    // this.getInfo();
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    //获取信息
    getInfo() {
      this.showLoading = true;
      let url = window.location.href.split("#")[0];
      this.$axios
        .get("/api/Djjl/GetActivityInfo", {
          params: {
            ActivityId: this.id, //url的参数id
            Url: url,
          },
        })
        .then((res) => {
          let data = res.data;
          // console.log(data);
          this.showLoading = false;
          if (data.type == 1) {
            this.hasLogin = data.hasLogin;
            this.canJoin = data.canJoin;
            this.canJoinMessage = data.canJoinMessage;
            this.activityEntity = data.activityEntity;
            this.activityCustomerEntity = data.activityCustomerEntity;
            this.sdkModel = data.sdkModel;
            if (!!data.activityEntity.ActivityArea) {
              //判断是否有小区
              this.hasActivityArea = true;
              this.temp.CustomerArea = data.activityEntity.ActivityArea;
            } else {
              this.hasActivityArea = false;
            }
            // console.log(this.hasActivityArea);
            if (!!this.sdkModel.shareImage) {
              if (this.sdkModel.shareImage.indexOf("http") == -1) {
                this.sdkModel.shareImage =
                  this.cusWebUrl + this.sdkModel.shareImage;
              }
            }
            if (!!data.activityEntity.ActivityPicture) {
              let arr = JSON.parse(data.activityEntity.ActivityPicture);
              this.ActivityPicture = arr.map((i) => {
                if (process.env.NODE_ENV === "production") {
                  i.Url = this.cusWebUrl + i.Url;
                } else {
                  i.Url = this.$axios.defaults.baseURL + i.Url;
                }
                return i;
              });
              // console.log(this.ActivityPicture)
            }
            if (!!this.activityEntity.ActivityExplain) {
              this.activityEntity.ActivityExplain =
                this.activityEntity.ActivityExplain.replace(/\n/g, "<br/>");
            }
            if (!!this.activityEntity.ActivityDetailListJson) {
              let activityDetailList = JSON.parse(
                this.activityEntity.ActivityDetailListJson
              );
              this.itemList = activityDetailList.map((i) => {
                i.JoinNum = 0;
                return i;
              });
            }
            if (this.activityCustomerEntity != null) {
              //已经报过名
              this.temp.ActivityId = this.activityCustomerEntity.ActivityId;
              this.temp.CustomerArea = this.activityCustomerEntity.CustomerArea;
              this.temp.CustomerName = this.activityCustomerEntity.CustomerName;
              this.temp.CustomerPhone =
                this.activityCustomerEntity.CustomerPhone;
              this.temp.Description = this.activityCustomerEntity.Description;
              // this.temp.CustomerBuilding =
              //   this.activityCustomerEntity.CustomerBuilding;
              this.temp.CustomerUnit = this.activityCustomerEntity.CustomerUnit;
              if (!!this.activityCustomerEntity.DetailListJson) {
                let detailList = JSON.parse(
                  this.activityCustomerEntity.DetailListJson
                );
                this.itemList = detailList.map((i) => {
                  return i;
                });
              }
            }

            this.$wx.config({
              debug: false,
              appId: data.sdkModel.appId,
              timestamp: data.sdkModel.timestamp,
              nonceStr: data.sdkModel.nonceStr,
              signature: data.sdkModel.signature,
              jsApiList: [
                "updateAppMessageShareData",
                "updateTimelineShareData",
              ],
            });
            setTimeout(() => {
              this.wxShare();
            }, 500);
            localStorage.removeItem(this.localStorageActivityKey);
            localStorage.removeItem(this.localStorageLoginPathKey);
            this.cookieUtil.delCookie(this.localStorageLoginPathKey);
          } else {
            // Toast.fail('操作失败！');
            Toast.fail({
              duration: 2000,
              forbidClick: true, // 禁用背景点击
              message: data.message,
            });
          }
        });
    },
    //点击报名
    handleJoin() {
      if (this.canJoin == 0) {
        //不可报名
        Toast.fail({
          duration: 2000,
          forbidClick: true, // 禁用背景点击
          message: this.canJoinMessage,
        });
        return;
      }
      if (this.hasLogin == 0) {
        //没有登录
        // Toast("请先登录！");
        localStorage.setItem(this.localStorageActivityKey, this.id); // activityId
        // localStorage.setItem("backUrl", window.location.href); // 记录登陆前路径
        // this.cookieUtil.setCookie('backUrl', window.location.href)
        let backUrl = `/jl-activity?id=${this.id}`;
        localStorage.setItem(this.localStorageLoginPathKey, backUrl); // 记录登陆前路径
        this.cookieUtil.setCookie(this.localStorageLoginPathKey, backUrl);
        this.$router.push(`/wxlogin`);
        return;
      }
      this.pageType = 2;
    },
    //提交资料
    handleSubmit() {
      if (!this.checkItemList()) {
        Toast.fail({
          duration: 2000,
          forbidClick: true, // 禁用背景点击
          message: "请选择空调数量",
        });
        return;
      }
      this.temp.ActivityId = this.id;
      this.temp.DetailListJson = JSON.stringify(this.itemList);
      // console.log(this.temp);
      this.submitLoading = true;
      this.$axios.post("/api/Djjl/JoinActivity", this.temp).then((res) => {
        let data = res.data;
        // console.log(data);
        this.submitLoading = false;
        if (data.type == 1) {
          this.totalJoinNum = data.totalJoinNum;
          if (!!data.joinList) {
            this.joinList = data.joinList.map((i) => {
              // if (process.env.NODE_ENV === "production") {
              //   i.HeadImgUrl = this.cusWebUrl + i.HeadImgUrl;
              // } else {
              //   i.HeadImgUrl = this.$axios.defaults.baseURL + i.HeadImgUrl;
              // }
              return i;
            });
          }
          this.pageType = 3;
        } else {
          Toast.fail({
            duration: 2000,
            forbidClick: true, // 禁用背景点击
            message: data.message,
          });
        }
      });
    },
    //检查数组是否填写
    checkItemList() {
      let flag = false;
      this.itemList.forEach((i) => {
        if (i.JoinNum > 0) {
          flag = true;
        }
      });
      return flag;
    },

    // 微信分享
    wxShare() {
      this.$wx.ready(() => {
        // 分享给朋友
        this.$wx.updateAppMessageShareData({
          title: `${this.sdkModel.shareTitle}`, // 分享标题
          desc: this.sdkModel.shareDes, // 分享描述
          link: this.thisWebUrl + this.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.sdkModel.shareImage, // 分享图标
          success: function () {
            // 设置成功
          },
        });
        // 分享到朋友圈
        this.$wx.updateTimelineShareData({
          title: `${this.sdkModel.shareTitle}`, // 分享标题
          link: this.thisWebUrl + this.id, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.sdkModel.shareImage, // 分享图标
          success: function () {
            // 设置成功
          },
        });
      });
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
>>> .el-form--label-top .el-form-item__label {
  padding: 0;
  line-height: 1.6;
  margin-bottom: 6px;
  font-size: 14px;
}

>>> .van-field {
  // border-bottom: 1px solid #DCDFE6;
}

>>> .van-checkbox {
  padding: 6px 0px;
}

.wrap {
  box-sizing: border-box;
}

.page-one {
  padding: 12px;
  box-sizing: border-box;
  height: 100vh;

  .swiper-wrap {
    width: 100%;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 20px;

    .swiper {
      width: 100%;

      & img {
        width: 100%;
      }
    }
  }

  .content-wrap {
    line-height: 1.6;
    margin-bottom: 100px;

    .has-num {
      margin-top: 20px;
    }
  }

  .page-one-bottom-btn {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    margin-top: 20px;
    z-index: 1999;
  }
}

.page-two {
  padding: 12px;
  box-sizing: border-box;
  height: 100vh;

  >>> .van-field__control--custom {
    justify-content: flex-end;
  }

  >>> .van-field__label {
    display: flex;
    align-items: center;
  }

  .title {
    margin-bottom: 20px;
  }

  .ptqk-title {
    margin: 20px 0px;
  }

  .form-wrap {
    margin-bottom: 100px;
  }

  .pt-wrap {
    margin-bottom: 100px;
  }

  .frame {
    border: 1px solid #DCDFE6;
    padding: 6px;
    box-sizing: border-box;
    margin-bottom: 12px;

    .frame-item {
      display: flex;
      align-items: center;

      .frame-item-name {
        width: 100px;
        height: 40px;
        box-sizing: border-box;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #57b885;
        color: #fff;
        font-size: 16px;
        padding: 12px 6px;
        border-radius: 4px;
        margin-right: 12px;
      }

      .qxz {
        background: #ea521a;
      }
    }

    .del-btn {
      display: flex;
      justify-content: flex-end;
    }
  }

  .form-btn {
    display: flex;
    justify-content: center;
  }

  .checkbox-item {
    // background: red;
    display: flex;
    align-items: center;

    .checkbox-item-checkbox {
    }

    .checkbox-item-field {
    }
  }

  .page-two-bottom-btn {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    margin-top: 20px;
    z-index: 1999;
  }
}

.page-three {
  padding: 12px;
  box-sizing: border-box;

  .success-wrap {
    box-sizing: border-box;

    .title {
      text-align: center;
      color: red;
      font-size: 20px;
    }

    .list {
      box-sizing: border-box;

      .item {
        display: flex;
        align-items: center;
        padding: 8px 0px;

        .icon {
          margin-right: 20px;

          img {
            width: 60px;
            height: 60px;
            border-radius: 50%;
            object-fit: cover;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/JlActivity/index.vue